export const mobileHeaderHeight = 62;

const sizes = {
  homeSideWhiteBox: '45vw',
  mainArticlePanelWidth: '483px',
  headerDesktopSize: '100px',
  headerMobileSize: `${mobileHeaderHeight}px`,
  logoDesktopSize: '46px',
  logoMobileSize: '32px',
  simpleHeaderDesktopSize: '70px',
  secondaryArticleSideWhiteBox: '46vw',
  animationsDefaultDistance: '180px',
  animationsDefaultDistanceSides: '180px',
  modalHeaderSize: '90px',
  transitionDuration: '.7s',
} as const;

export default sizes;
